import { Component, OnInit, ViewChild, OnDestroy, AfterViewInit } from '@angular/core';
import { DataService } from '../../../../services/data.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { NgForm } from '@angular/forms';
import { ConfirmationPageSuccessComponent } from '../../../../shared-components/confirmation-page-success/confirmation-page-success.component';
import { ConfirmationPageFailComponent } from '../../../../shared-components/confirmation-page-fail/confirmation-page-fail.component';
import { BusyIndicatorComponent } from '../../../../shared-components/busy-indicator/busy-indicator.component';
import { Code } from '../../../../models/Code';
import { NgSelectModule } from '@ng-select/ng-select';
import { CoverageSearchResult } from '../../../../models/CoverageSearchResult';
import { VendorService } from '../../../../services/vendor.service';
import { ModalComponent } from '../../../../shared-components/modal/modal.component';
import { AccountService } from '../../../../services/account.service';
import { Router } from '@angular/router';
import { VendorClientDetailsSearchResult } from '../../../../models/VendorClientDetailsSearchResult';

@Component({
  selector: 'app-coverage-search',
  templateUrl: './coverage-search.component.html',
  styleUrls: ['./coverage-search.component.scss']
})
export class CoverageSearchComponent implements OnInit, AfterViewInit, OnDestroy {
  searchResult: CoverageSearchResult;
  currSearchResult: VendorClientDetailsSearchResult;
  searchTypes: Code[] =  [];
  searchType: number;
  searchText: string;
  gpVID = '';
  maxAllowedSearches = 0;
  errorMsg: string;
  showFailConfirmation: boolean;
  alive = true;
  termsOfUse: string;
  privacyPolicy: string;
  @ViewChild('privacy') privacy: ModalComponent;
  constructor(private dataSvc: DataService,
    private vendorSvc: VendorService,
    private accountSvc: AccountService,
    private router: Router,
    private spinner: NgxSpinnerService
  ) {
    this.gpVID = dataSvc.userDisplayInfo.GPVID;
    this.maxAllowedSearches = dataSvc.userDisplayInfo.MaxAllowedCoverageSearches;
  }

  ngOnInit() {
    this.getSearchTypes();
  }

  async ngAfterViewInit() {
    this.termsOfUse = await this.accountSvc.getHtmlFile('terms');
    this.privacyPolicy = await this.accountSvc.getHtmlFile('privacy');
    if (!this.dataSvc.userDisplayInfo.IsCoveragePrivacyPolicyAccepted) {
      this.privacy.show();
    }
  }

  getSearchTypes() {
    this.vendorSvc.getVendorClientSearchTypes()
          .takeWhile(() => this.alive)
          .subscribe(
            data => {
              this.searchTypes = data;
          }
      );
  }

  close() {
    this.showFailConfirmation = false;
  }

  onSubmit() {
      if (this.dataSvc.userDisplayInfo.IsCoveragePrivacyPolicyAccepted) {
        this.errorMsg = null;
        this.spinner.show();
        this.vendorSvc.getVendorClientDetails(this.searchType, this.searchText, this.maxAllowedSearches, this.gpVID)
        .takeWhile(() => this.alive)
        .subscribe(
          data => {
                    this.spinner.hide();
                    this.searchResult = data;
                    if (data && data.SearchResult.length === 1) {
                      this.currSearchResult = this.searchResult.SearchResult[0];
                    }
                },
          err => {
                    this.spinner.hide();
                    this.showFailConfirmation = true;
                    this.errorMsg = err._body;
            }
        );
      } else {
        this.router.navigateByUrl('/pages/vendor/myvendor/home');
      }
  }

  showDetails(result: VendorClientDetailsSearchResult) {
    this.currSearchResult = result;
  }

  onAccept() {
    this.privacy.hide();

    // update privacy date
    this.vendorSvc.updateCoverageSearchPrivacyDate()
      .takeWhile(() => this.alive)
      .subscribe(
        data => {
          this.dataSvc.userDisplayInfo.IsCoveragePrivacyPolicyAccepted = true;
        },
        err => {
          this.errorMsg = err;
          this.showFailConfirmation = true;
        },
        () => console.log('Request Complete')
      );
  }

  onReject() {
    this.privacy.hide();
    this.router.navigateByUrl('/pages/vendor/myvendor/home');
  }

  ngOnDestroy() {
    this.alive = false;
  }

}



// WEBPACK FOOTER //
// ./src/app/pages/vendor/my-vendor/coverage-search/coverage-search.component.ts